import gql from "graphql-tag";

export const DELETE_CREW_RESOURCES_MUTATION = gql`
  mutation deleteCrewResources($resourceIDs: [String]! ){
    deleteCrewResources(resourceIDs: $resourceIDs)
  }
`;